import {defaultCurrency, defaultPartner, defaultSorting} from '../../../config/app-config';
import {
  FETCH_SRP_DATA,
  ISrpStoreState,
  RESET_FILTER,
  SrpActionTypes,
  TOGGLE_LOADING,
  UPDATE_FILTER,
  UPDATE_SRP_CONFIG,
  RESET_SRP_DATA,
  UPDATE_SRP_OFFER_DATA,
  UPDATE_SEO_FLAGS,
  UPDATE_SRP_SEO_DATA,
} from './types';

const initialState: ISrpStoreState = {
  hasData: null,
  isLoading: false,
  displayOverlay: false,
  partner: defaultPartner,
  srpConfig: {
    s: defaultSorting,
    cur: defaultCurrency,
    im: true,
    filter: {},
    seoViewMore: false,
  },
  srpData: {
    city_meta_info: null,
    data: [],
    next: '',
    error: false,
  },
  srpOfferData: null,
  isSEO: false,
  seoData: {
    article: {
      desc: '',
      title: '',
    },
    pageTitle: '',
    pageHeading: '',
    faqs: [],
    meta: [],
    breadCrumbData: [],
    filterLinks: [],
    seoLinks: [],
    topContent: {
      description: '',
      title: '',
    },
  },
};

export default function srpPageReducer(state = initialState, action: SrpActionTypes) {
  switch (action.type) {
    case UPDATE_SRP_CONFIG:
      return {
        ...state,
        srpConfig: {
          ...state.srpConfig,
          ...action.actionData,
          seoViewMore: false,
        },
      };

    case FETCH_SRP_DATA:
      const {srpData} = state;
      const {data: currentData} = srpData;
      if (action.loadingMore) {
        return {
          ...state,
          srpData: {
            ...state.srpData,
            data: [...currentData, ...action?.actionData?.data],
            next: action?.actionData?.next,
            error: action?.actionData?.error || false,
          },
          hasData: action?.actionData?.data?.length > 0,
        };
      }

      return {
        ...state,
        srpData: {
          city_meta_info: action?.actionData?.city_meta_info,
          data: action?.actionData?.data,
          next: action?.actionData?.next,
          error: action?.actionData?.error || false,
        },
        hasData: action?.actionData?.data?.length > 0,
      };

    case UPDATE_FILTER:
      return {
        ...state,
        srpConfig: {
          ...state.srpConfig,
          filter: {
            ...state.srpConfig.filter,
            ...action.actionData,
          },
          seoViewMore: false,
        },
      };

    case RESET_FILTER:
      return {
        ...state,
        srpConfig: {
          ...state.srpConfig,
          filter: {},
        },
      };

    case UPDATE_SRP_OFFER_DATA:
      return {
        ...state,
        srpOfferData: {
          ...state.srpOfferData,
          ...action.actionData,
        },
      };

    case TOGGLE_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
        displayOverlay: action.displayOverlay,
      };

    case RESET_SRP_DATA:
      return {
        ...state,
        ...initialState,
      };
    case UPDATE_SEO_FLAGS:
      return {
        ...state,
        isSEO: action.actionData.isSEO,
        srpConfig: {...state.srpConfig, seoViewMore: action.actionData.seoViewMore},
      };
    case UPDATE_SRP_SEO_DATA:
      return {
        ...state,
        seoData: {
          ...state.seoData,
          ...action.actionData,
        },
      };
    default:
      return state;
  }
}
